"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectConnectivityStatus = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _ErrorNotificationIcon = _interopRequireDefault(require("../Attachment/Assets/ErrorNotificationIcon"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _SpinnerAnimation = _interopRequireDefault(require("../Attachment/Assets/SpinnerAnimation"));

var _useConnectivityStatus = _interopRequireDefault(require("../hooks/useConnectivityStatus"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

var _WarningNotificationIcon = _interopRequireDefault(require("../Attachment/Assets/WarningNotificationIcon"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CONNECTIVITY_STATUS_DEBOUNCE = 400;

function setTimeoutSync(fn, interval) {
  if (interval > 0) {
    return setTimeout(fn, interval);
  }

  fn();
}

var DebouncedConnectivityStatus = function DebouncedConnectivityStatus(_ref) {
  var interval = _ref.interval,
      propsChildren = _ref.children;

  var _useState = (0, _react.useState)(function () {
    return propsChildren;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      children = _useState2[0],
      setChildren = _useState2[1];

  var _useState3 = (0, _react.useState)(Date.now()),
      _useState4 = _slicedToArray(_useState3, 2),
      since = _useState4[0],
      setSince = _useState4[1];

  var intervalBeforeSwitch = Math.max(0, interval - Date.now() + since);
  (0, _react.useEffect)(function () {
    if (children !== propsChildren) {
      var timeout = setTimeoutSync(function () {
        setChildren(function () {
          return propsChildren;
        });
        setSince(Date.now());
      }, intervalBeforeSwitch);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [children, intervalBeforeSwitch, propsChildren]);
  return typeof children === 'function' ? children() : false;
};

DebouncedConnectivityStatus.defaultProps = {
  children: undefined
};
DebouncedConnectivityStatus.propTypes = {
  children: _propTypes.default.any,
  interval: _propTypes.default.number.isRequired
};

var connectConnectivityStatus = function connectConnectivityStatus() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref2) {
    var connectivityStatus = _ref2.connectivityStatus,
        language = _ref2.language;
    return {
      connectivityStatus: connectivityStatus,
      language: language
    };
  }].concat(selectors));
};

exports.connectConnectivityStatus = connectConnectivityStatus;

var ConnectivityStatus = function ConnectivityStatus() {
  var _useConnectivityStatu = (0, _useConnectivityStatus.default)(),
      _useConnectivityStatu2 = _slicedToArray(_useConnectivityStatu, 1),
      connectivityStatus = _useConnectivityStatu2[0];

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      _useStyleSet2$ = _useStyleSet2[0],
      connectivityNotificationStyleSet = _useStyleSet2$.connectivityNotification,
      errorNotificationStyleSet = _useStyleSet2$.errorNotification,
      warningNotificationStyleSet = _useStyleSet2$.warningNotification;

  var connectedNotificationText = (0, _useLocalize.default)('CONNECTED_NOTIFICATION');
  var failedConnectionText = (0, _useLocalize.default)('FAILED_CONNECTION_NOTIFICATION');
  var initialConnectionText = (0, _useLocalize.default)('INITIAL_CONNECTION_NOTIFICATION');
  var interruptedConnectionText = (0, _useLocalize.default)('INTERRUPTED_CONNECTION_NOTIFICATION');
  var renderErrorNotificationText = (0, _useLocalize.default)('RENDER_ERROR_NOTIFICATION');
  var slowConnectionText = (0, _useLocalize.default)('SLOW_CONNECTION_NOTIFICATION');
  var connectivityStatusLabelText = (0, _useLocalize.default)('ConnectivityStatus');
  var renderConnectingSlow = (0, _react.useCallback)(function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + slowConnectionText
    }), _react.default.createElement("div", {
      "aria-hidden": true,
      className: warningNotificationStyleSet
    }, _react.default.createElement(_WarningNotificationIcon.default, null), slowConnectionText));
  }, [connectivityStatusLabelText, slowConnectionText, warningNotificationStyleSet]);
  var renderNotConnected = (0, _react.useCallback)(function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + failedConnectionText
    }), _react.default.createElement("div", {
      "aria-hidden": true,
      className: errorNotificationStyleSet
    }, _react.default.createElement(_ErrorNotificationIcon.default, null), failedConnectionText));
  }, [connectivityStatusLabelText, errorNotificationStyleSet, failedConnectionText]);
  var renderUninitialized = (0, _react.useCallback)(function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + initialConnectionText
    }), _react.default.createElement("div", {
      "aria-hidden": true,
      className: connectivityNotificationStyleSet
    }, _react.default.createElement(_SpinnerAnimation.default, null), initialConnectionText));
  }, [connectivityNotificationStyleSet, connectivityStatusLabelText, initialConnectionText]);
  var renderReconnecting = (0, _react.useCallback)(function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + interruptedConnectionText
    }), _react.default.createElement("div", {
      "aria-hidden": true,
      className: connectivityNotificationStyleSet
    }, _react.default.createElement(_SpinnerAnimation.default, null), interruptedConnectionText));
  }, [connectivityNotificationStyleSet, connectivityStatusLabelText, interruptedConnectionText]);
  var renderSagaError = (0, _react.useCallback)(function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + renderErrorNotificationText
    }), _react.default.createElement("div", {
      "aria-hidden": true,
      className: errorNotificationStyleSet
    }, _react.default.createElement(_ErrorNotificationIcon.default, null), renderErrorNotificationText));
  }, [connectivityStatusLabelText, errorNotificationStyleSet, renderErrorNotificationText]);
  var renderEmptyStatus = (0, _react.useCallback)(function () {
    return _react.default.createElement(_ScreenReaderText.default, {
      text: connectivityStatusLabelText + connectedNotificationText
    });
  }, [connectedNotificationText, connectivityStatusLabelText]);
  var renderStatus = (0, _react.useCallback)(function () {
    if (connectivityStatus === 'connectingslow') {
      return renderConnectingSlow();
    } else if (connectivityStatus === 'error' || connectivityStatus === 'notconnected') {
      return renderNotConnected();
    } else if (connectivityStatus === 'uninitialized') {
      return renderUninitialized();
    } else if (connectivityStatus === 'reconnecting') {
      return renderReconnecting();
    } else if (connectivityStatus === 'sagaerror') {
      return renderSagaError();
    }

    return renderEmptyStatus();
  }, [connectivityStatus, renderConnectingSlow, renderEmptyStatus, renderNotConnected, renderReconnecting, renderSagaError, renderUninitialized]);
  return _react.default.createElement("div", {
    "aria-label": " ",
    role: "status"
  }, _react.default.createElement(DebouncedConnectivityStatus, {
    interval: connectivityStatus === 'uninitialized' || connectivityStatus === 'error' ? 0 : CONNECTIVITY_STATUS_DEBOUNCE
  }, renderStatus));
};

var _default = ConnectivityStatus;
exports.default = _default;